import { IEvent, IHost } from "@Interfaces";
import { EVENT_TYPE, ACTION_TYPES, createAction } from "@Utils";
import { useDispatch } from "react-redux";

export const useSetQuantity = () => {
    const dispatch = useDispatch();
    const setQuantity = (quantity: IEvent.IPaymentInfo["quantity"]) => {
        dispatch(
            createAction(ACTION_TYPES.EVENT.UPDATE_BOOKING_DATA, {
                quantity,
            })
        );
    };

    return setQuantity;
};

export const isMerchandise = ({
    type,
}: IEvent.IUpsellOffering | IEvent.IEventData): boolean =>
    type === EVENT_TYPE.MERCHANDISE;

export const getPlanData = ({
    host,
    planId,
}: {
    host: IHost.IStore;
    planId?: string;
}) => {
    let planData: IHost.IPlanDetail = { listings: [] };
    if (planId) {
        planData = {
            ...planData,
            ...host?.plans?.details?.[planId],
            ...host?.plans?.list?.filter(p => p.uuid === planId)?.[0],
        };
    }

    return planData;
};
